<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    variant="light"
    opacity="0.85"
    blur="2px"
    rounded="lg"
    spinner-variant="primary"
  >
    <div class="vx-row">
      <div class="vx-col w-full">
        <b-card>
          <h4 class="heading mb-10">{{ $t("SystemSettings") }}</h4>
          <form method="post" v-on:submit.prevent="$event.preventDefault()">
            <div class="vx-row mt-10">
              <div
                class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
              >
                <label class="vs-input--label"
                  >{{ $t("InstanceName") }} <span class="red">*</span></label
                >
                <div class="flex items-start flex-col sm:flex-row w-full">
                  <b-input
                    size="lg"
                    v-validate="'required'"
                    :data-vv-as="$t('InstanceName')"
                    name="InstanceName"
                    v-model="title"
                    class="w-full"
                    :placeholder="$t('InstanceName')"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('InstanceName')"
                  >{{ errors.first("InstanceName") }}</span
                >
              </div>

              <div
                class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
              >
                <label class="vs-input--label"
                  >{{ $t("Copyright") }} <span class="red">*</span></label
                >
                <div class="flex items-start flex-col sm:flex-row w-full">
                  <b-input
                    size="lg"
                    v-validate="{
                      required: true,
                    }"
                    :data-vv-as="$t('Copyright')"
                    name="copyright"
                    v-model="copyright_text"
                    class="w-full"
                    :placeholder="$t('Copyright')"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('copyright')"
                  >{{ errors.first("copyright") }}</span
                >
              </div>

              <div
                class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
              >
                <label class="vs-input--label"
                  >{{ $t("FooterUrl") }} <span class="red">*</span></label
                >
                <div class="flex items-start flex-col sm:flex-row w-full">
                  <b-input
                    size="lg"
                    v-validate="{
                      required: true,
                      regex: /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
                    }"
                    :data-vv-as="$t('FooterUrl')"
                    name="FooterUrl"
                    v-model="live_url"
                    class="w-full"
                    :placeholder="$t('FooterUrl')"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('FooterUrl')"
                  >{{ errors.first("FooterUrl") }}</span
                >
              </div>
              <div
                class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
              >
                <label class="vs-input--label"
                  >{{ $t("EmbedUrl") }} <span class="red">*</span></label
                >
                <div class="flex items-start flex-col sm:flex-row w-full">
                  <b-input
                    size="lg"
                    v-validate="{
                      required: true,
                      regex: /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/,
                    }"
                    :data-vv-as="$t('EmbedUrl')"
                    name="EmbedUrl"
                    v-model="embed_url"
                    class="w-full"
                    :placeholder="$t('EmbedUrl')"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('EmbedUrl')"
                  >{{ errors.first("EmbedUrl") }}</span
                >
              </div>
            </div>

            <div class="vx-col">
              <b-button
                variant="primary"
                class="mr-4 mt-10"
                @click="submitFiles('title')"
                >{{ $t("Update") }}</b-button
              >
            </div>
          </form>
        </b-card>
        <b-card class="mt-10">
          <!-- <h4 class="heading mb-10">{{ $t("SystemSettings") }}</h4> -->

          <div class="export-table mt-10">
            <form method="post" v-on:submit.prevent="$event.preventDefault()">
              <div class="vx-row images mt-10">
                <div
                  class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
                >
                  <div class="flex items-start flex-col sm:flex-row w-full">
                    <img :src="logo" class="mr-8 rounded" width="150px" />
                    <div>
                      <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
                      <input
                        type="file"
                        class="hidden"
                        ref="updateImgInput"
                        accept="image/*"
                        name="logo"
                        id="logo"
                        @change="selectedFile"
                      />
                      <b-button
                        variant="primary"
                        class="mr-4 mb-4 mt-5"
                        @click="$refs.updateImgInput.click()"
                        >{{ $t("LogoChange") }}</b-button
                      >
                    </div>
                  </div>
                  <div class="w-full mt-5">
                    <small class="text-dark">
                      {{ $t("Note1") }}
                    </small>
                  </div>
                </div>

                <div
                  class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
                >
                  <div class="flex items-start flex-col sm:flex-row">
                    <img :src="image" class="mr-8 rounded w-40" width="150px" />
                    <div>
                      <input
                        type="file"
                        class="hidden"
                        ref="updateImgInput1"
                        accept="image/*"
                        name="image"
                        id="image"
                        :data-vv-as="$t('BackgroundImage')"
                        @change="selectedFile"
                      />
                      <b-button
                        variant="primary"
                        class="mr-4 mb-4 mt-5"
                        @click="$refs.updateImgInput1.click()"
                        >{{ $t("BackgroundChange") }}</b-button
                      >
                    </div>
                  </div>
                  <div class="w-full mt-5">
                    <small class="text-dark">
                      {{ $t("Note2") }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="vx-row images mt-10"></div>

              <div class="vx-row images mt-10">
                <!-- <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5">
                <div class="flex items-start flex-col sm:flex-row">
                  <img :src="loader" class="mr-8 rounded w-40" width="150px" />
                  <div>
                    <input
                      type="file"
                      class="hidden"
                      ref="updateImgInput2"
                      accept="image/*"
                      name="loader"
                      id="loader"
                      :data-vv-as="$t('LoaderImage')"
                      @change="selectedFile"
                    />
                    <b-button
                      variant="primary"
                      class="mr-4 mb-4 mt-5"
                      @click="$refs.updateImgInput2.click()"
                      >{{ $t("LoaderChange") }}</b-button
                    >
                  </div>
                </div>
                <div class="w-full mt-5">
              <small class="text-dark">
                {{ $t("Note3") }}
              </small>
            </div>
              </div> -->
                <div
                  class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-5"
                >
                  <div class="flex items-start flex-col sm:flex-row">
                    <img
                      :src="favicon"
                      class="mr-8 rounded w-40"
                      style="max-width: 150px"
                    />
                    <div>
                      <input
                        type="file"
                        class="hidden"
                        ref="updateImgInput3"
                        accept="image/*"
                        name="favicon"
                        id="favicon"
                        :data-vv-as="$t('FaviconImage')"
                        @change="selectedFile"
                      />
                      <b-button
                        variant="primary"
                        class="mr-4 mb-4 mt-5"
                        @click="$refs.updateImgInput3.click()"
                        >{{ $t("FaviconChange") }}</b-button
                      >
                    </div>
                  </div>
                  <div class="w-full mt-5">
                    <small class="text-dark">
                      {{ $t("Note4") }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="vx-row images mt-10">
                <div class="vx-col w-full">
                  <b-button
                    variant="primary"
                    class="mb-4"
                    @click="submitFiles('images')"
                    >{{ $t("Update") }}</b-button
                  >
                </div>
              </div>
            </form>
          </div>
        </b-card>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { Validator } from "vee-validate";
import $ from "jquery";
import Cookies from "js-cookie";
import VxCard from "../../../../book-appointment/src/components/vx-card/VxCard.vue";

export default {
  components: { VxCard },
  data() {
    return {
      title: "",
      live_url: "",
      embed_url: "",
      copyright_text: "",
      logo: "",
      image: "",
      loader: "",
      waiting_logo: "",
      favicon: "",
      images_data: [],
      images: [],
      logo_obj: [],
      back_obj: [],
      loader_obj: [],
      favicon_obj: [],
      waiting_logo_obj: [],
      show: false,
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  created() {
    this.getSettings();
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },

  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *
     * handleSubmit    method  for submit data from profile form     **/

    submitFiles(type) {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.show = true;
          let formData = new FormData();
          formData.append("id", this.images_data.id);
          if (type == "title") {
            formData.append("title", this.title);
            formData.append("live_url", this.live_url);
            formData.append("embed_url", this.embed_url);
            formData.append("copyright_text", this.copyright_text);
          } else {
            formData.append("logo", this.logo_obj);
            formData.append("background_image", this.back_obj);
            formData.append("loader_image", this.loader_obj);
            formData.append("favicon_image", this.favicon_obj);
            formData.append("waiting_logo_image", this.waiting_logo_obj);
          }

          this.$store
            .dispatch("SystemAdd", formData)
            .then((response) => {
              if (type != "title") this.getSettings();
              else {
                document.title = this.title;

                this.$store.getters.whitelabel.title = this.title;
                this.$store.getters.whitelabel.live_url = this.live_url;
                this.$store.getters.whitelabel.copyright_text = this.copyright_text;
                this.$store.commit(
                  "SET_WHITELABEL",
                  this.$store.getters.whitelabel
                );
              }
              this.show = false;

              this.$toasted.show(this.$t("SettingUpdateSuccess"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            })
            .catch((error) => {
              this.show = false;
              // Error response
              this.error =
                this.$t(error.replace(/[\s\/]/g, "")) !==
                error.replace(/[\s\/]/g, "")
                  ? this.$t(error.replace(/[\s\/]/g, ""))
                  : error;
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
              return false;
            });
        }
      });
    },

    /**
     * image validation
     */
    selectedFile(event) {
      var filePath = event.target.files[0].name;
      let ext;
      if (event.target.name == "favicon") {
        var allowedExtensions = /(\.ico)$/i;
        ext = ".ico";
      } else {
        var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
        ext = "jpg, .jpeg, .png, .gif";
      }

      if (!allowedExtensions.exec(filePath)) {
        this.error = this.$t("FileUploadError").replace(
          ".jpeg .jpg .png .gif",
          ext
        );
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });

        $("#profile_image").val("");
      } else {
        this.images = event.target.files[0];
        if (event.target.name == "logo") {
          this.logo = URL.createObjectURL(this.images);
          this.logo_obj = this.images;
        }

        if (event.target.name == "image") {
          this.image = URL.createObjectURL(this.images);
          this.back_obj = this.images;
        }

        if (event.target.name == "loader") {
          this.loader = URL.createObjectURL(this.images);
          this.loader_obj = this.images;
        }
        if (event.target.name == "favicon") {
          this.favicon = URL.createObjectURL(this.images);
          this.favicon_obj = this.images;
        }
        if (event.target.name == "waiting_logo") {
          this.waiting_logo = URL.createObjectURL(this.images);
          this.waiting_logo_obj = this.images;
        }
      }
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    // get
    getSettings() {
      this.$store
        .dispatch("GetSystemSettings")
        .then((res) => {
          this.show = false;
          this.images_data = res.data.data;
          this.title = this.images_data.title;
          this.logo = this.images_data.logo.path;
          this.image = this.images_data.background_image.path;
          this.loader = this.images_data.loader_image.path;
          this.waiting_logo = this.images_data.waiting_logo_image.path;
          this.favicon = this.images_data.favicon_image.path;
          this.live_url = this.images_data.live_url;
          this.embed_url = this.images_data.embed_url;
          this.copyright_text = this.images_data.copyright_text;
          this.$store.commit("SET_WHITELABEL", res.data.data);
          const favicon = document.getElementById("favicon");
          favicon.href = this.favicon;
        })
        .catch((error) => {
          this.$log.error(
            "File : getSetting.vue | Function : getSettings() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}

.v-select {
  min-width: 180px;
}

.vs-con-table .vs-con-tbody {
  width: 100%;
  overflow: visible;
}
</style>